import React from 'react'

import TableCellWithPopup from './components/TableCellWithPopup'
import PopupMenuContractName from './components/PopupMenuContractName'
import PopupMenuContractRegNumber from './components/PopupMenuContractRegNumber'
import PopupMenuContractStatus from './components/PopupMenuContractStatus'
import PopupMenuSubjectContract from './components/PopupMenuSubjectContract'
import PopupMenuPrice from './components/PopupMenuPrice'
import PopupMenuDateContract from './components/PopupMenuDateContract'
import PopupMenuDateContractEndExecution from './components/PopupMenuDateContractEndExecution'
import PopupMenuTypeObjectContract from './components/PopupMenuTypeObjectContract'
import PopupMenuStruct from './components/PopupMenuStruct'
import PopupMenuDateCreated from './components/PopupMenuDateCreated'
import PopupMenuSupervisorUser from './components/PopupMenuSupervisorUser'

import { UserFilter, SortOrder } from './FilterTypes'

import HoverTooltip from '../../../../../components/HoverTooltip'

type Props = {
    stage: string
    hasScroll: boolean
    filter: UserFilter | null
    theme: string
    onFilterErase: () => void
    onAcceptFilter: () => void

    // Фильтрация по столбцу "Номер договора"
    onChangeFilterSettingCriteriaContractNameSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaContractName: (values: string | null) => void

    // Фильтрация по столбцу "Реестровый номер договора"
    onChangeFilterSettingCriteriaContractRegNumberSort: (
        value: SortOrder
    ) => void
    onChangeFilterSettingCriteriaContractRegNumber: (
        values: string | null
    ) => void

    // Фильтрация по столбцу "Статус позиции"
    onChangeFilterSettingCriteriaContractStatusSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaContractStatus: (
        values: string[] | null
    ) => void

    // Фильтрация по столбцу "Предмет догвоора"
    onChangeFilterSettingCriteriaSubjectContractSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaSubjectContract: (
        values: string | null
    ) => void

    // Фильтрация по столбцу "НМЦД"
    onChangeFilterSettingCriteriaPriceSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaPrice: (
        valueMin: number | null,
        valueMax: number | null
    ) => void

    // Фильтрация по столбцу "Дата договора"
    onChangeFilterSettingCriteriaContractDateSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaContractDate: (
        valueFrom: string | null,
        valueTo: string | null
    ) => void

    // Фильтрация по столбцу "Срок исполнения"
    onChangeFilterSettingCriteriaContractEndExecutionDateSort: (
        value: SortOrder
    ) => void
    onChangeFilterSettingCriteriaContractEndExecutionDate: (
        valueFrom: string | null,
        valueTo: string | null
    ) => void

    // Фильтрация по столбцу "Тип ТРУ"
    onChangeFilterSettingCriteriaTypeObjectContractSort: (
        value: SortOrder
    ) => void
    onChangeFilterSettingCriteriaTypeObjectContract: (
        values: (string | null)[] | null
    ) => void

    // Фильтрация по столбцу "Структуре"
    onChangeFilterSettingCriteriaStructGuidSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaStructGuid: (
        values: (string | null)[] | null
    ) => void

    // Фильтрация по столбцу "Дата создания"
    onChangeFilterSettingCriteriaCreatedDateSort: (value: SortOrder) => void
    onChangeFilterSettingCriteriaCreatedDate: (
        valueFrom: string | null,
        valueTo: string | null
    ) => void

    // Фильтрация по столбцу "Пользователь"
    onChangeFilterSettingCriteriaSupervisorUserGuidSort: (
        value: SortOrder
    ) => void
    onChangeFilterSettingCriteriaSupervisorUserGuid: (
        values: (string | null)[] | null
    ) => void
}

const TableHeader: React.FC<Props> = (props) => {
    return (
        <div className="flex flex-row gap-1 p-1 items-center justify-center text-[10px] text-[#616173] dark:text-[#8A8A8A] bg-[#e4e7ea] dark:bg-[#262427]">
            <div className="flex w-8 h-full p-1 items-center justify-center text-center rounded-[10px] ">
                {props.filter?.filter_settings.filter_enabled ? (
                    <button
                        className={`flex w-fit h-fit p-1 items-center justify-center rounded-full ${props.filter?.filter_settings.criteria != null ? (props.theme == 'dark' ? 'dark:hover:bg-[#464447]' : 'hover:bg-[#FFFFFF]') : ''}`}
                        disabled={
                            props.filter?.filter_settings.criteria != null
                                ? false
                                : true
                        }
                        onClick={() => {
                            props.onFilterErase()
                        }}
                    >
                        <HoverTooltip tooltipText="Очистить фильтр">
                            <svg
                                className="w-4 h-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 30 30"
                                id="eraser"
                                fill={`${props.filter?.filter_settings.criteria != null ? (props.theme == 'dark' ? '#FFFFFF' : '#181818') : '#8A8A8A'}`}
                            >
                                <g>
                                    <path
                                        d="M28.7,8.9l-5.7-5.7c-1.1-1.1-3.1-1.1-4.2,0l-7.1,7.1c0,0,0,0,0,0s0,0,0,0l-7.5,7.5c-1.2,1.2-1.2,3.1,0,4.2l3.8,3.8
                       c0.2,0.2,0.4,0.3,0.7,0.3h6.6c0.3,0,0.5-0.1,0.7-0.3l12.7-12.7c0,0,0,0,0,0C29.9,12,29.9,10.1,28.7,8.9z M14.9,24.1H9.2l-3.5-3.5
                       c-0.4-0.4-0.4-1,0-1.4l6.8-6.8l7.1,7.1L14.9,24.1z"
                                    />
                                    <path d="M27,28H5c-0.6,0-1,0.4-1,1s0.4,1,1,1h22c0.6,0,1-0.4,1-1S27.6,28,27,28z" />
                                </g>
                            </svg>
                        </HoverTooltip>
                    </button>
                ) : (
                    ''
                )}
            </div>

            <div className="flex w-12 items-center justify-center text-center h-full rounded-[10px] p-1">
                №
            </div>

            <div className="flex w-20 items-center justify-center text-center h-full rounded-[10px] p-1">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuContractName}
                        stage={props.stage}
                        popupProps={{
                            criteriaContractName:
                                props.filter.filter_settings.criteria
                                    ?.contract_name,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaContractNameSort:
                                props.onChangeFilterSettingCriteriaContractNameSort,
                            onChangeFilterSettingCriteriaContractName:
                                props.onChangeFilterSettingCriteriaContractName,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Номер договора
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.contract_name?.query ||
                            props.filter?.filter_settings.criteria
                                ?.contract_name?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Номер договора
                        </div>
                    </div>
                )}
            </div>

            <div className="flex w-24 items-center justify-center text-center h-full rounded-[10px] p-1">
                Стадия
            </div>

            <div className="flex flex-col w-24 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuContractStatus}
                        stage={props.stage}
                        popupProps={{
                            criteriaContractStatus:
                                props.filter.filter_settings.criteria
                                    ?.contract_status,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaContractStatusSort:
                                props.onChangeFilterSettingCriteriaContractStatusSort,
                            onChangeFilterSettingCriteriaContractStatus:
                                props.onChangeFilterSettingCriteriaContractStatus,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Статус
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.contract_status?.values ||
                            props.filter?.filter_settings.criteria
                                ?.contract_status?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Статус
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-col flex-1 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuSubjectContract}
                        stage={props.stage}
                        popupProps={{
                            criteriaSubjectContract:
                                props.filter.filter_settings.criteria
                                    ?.subject_contract,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaSubjectContractSort:
                                props.onChangeFilterSettingCriteriaSubjectContractSort,
                            onChangeFilterSettingCriteriaSubjectContract:
                                props.onChangeFilterSettingCriteriaSubjectContract,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Предмет договора
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.subject_contract?.query ||
                            props.filter?.filter_settings.criteria
                                ?.subject_contract?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Предмет договора
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-col w-28 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuPrice}
                        stage={props.stage}
                        popupProps={{
                            criteriaPrice:
                                props.filter.filter_settings.criteria?.price,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaPriceSort:
                                props.onChangeFilterSettingCriteriaPriceSort,
                            onChangeFilterSettingCriteriaPrice:
                                props.onChangeFilterSettingCriteriaPrice,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Сумма договора
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria?.price
                                ?.min ||
                            props.filter?.filter_settings.criteria?.price
                                ?.max ||
                            props.filter?.filter_settings.criteria?.price
                                ?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Сумма договора
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-col w-28 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuDateContract}
                        stage={props.stage}
                        popupProps={{
                            criteriaContractDate:
                                props.filter.filter_settings.criteria
                                    ?.contract_date,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaContractDateSort:
                                props.onChangeFilterSettingCriteriaContractDateSort,
                            onChangeFilterSettingCriteriaContractDate:
                                props.onChangeFilterSettingCriteriaContractDate,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Дата договора
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.contract_date?.from ||
                            props.filter?.filter_settings.criteria
                                ?.contract_date?.to ||
                            props.filter?.filter_settings.criteria
                                ?.contract_date?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Дата договора
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-col w-28 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuDateContractEndExecution}
                        stage={props.stage}
                        popupProps={{
                            criteriaContractEndExecutionDate:
                                props.filter.filter_settings.criteria
                                    ?.end_execution_date,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaContractEndExecutionDateSort:
                                props.onChangeFilterSettingCriteriaContractEndExecutionDateSort,
                            onChangeFilterSettingCriteriaContractEndExecutionDate:
                                props.onChangeFilterSettingCriteriaContractEndExecutionDate,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Срок исполнения
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.end_execution_date?.from ||
                            props.filter?.filter_settings.criteria
                                ?.end_execution_date?.to ||
                            props.filter?.filter_settings.criteria
                                ?.end_execution_date?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Срок исполнения
                        </div>
                    </div>
                )}
            </div>

            <div className="flex w-44 items-center justify-center text-center h-full rounded-[10px] p-1">
                Контрагент
            </div>

            <div className="flex flex-col w-24 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuTypeObjectContract}
                        stage={props.stage}
                        popupProps={{
                            criteriaTypeObjectContract:
                                props.filter.filter_settings.criteria
                                    ?.type_object_contract,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaTypeObjectContractSort:
                                props.onChangeFilterSettingCriteriaTypeObjectContractSort,
                            onChangeFilterSettingCriteriaTypeObjectContract:
                                props.onChangeFilterSettingCriteriaTypeObjectContract,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Тип объекта закупки
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.type_object_contract?.values ||
                            props.filter?.filter_settings.criteria
                                ?.type_object_contract?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Тип объекта закупки
                        </div>
                    </div>
                )}
            </div>
            <div className="flex flex-col w-24 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuStruct}
                        stage={props.stage}
                        popupProps={{
                            criteriaStructGuid:
                                props.filter.filter_settings.criteria
                                    ?.struct_guid,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaStructGuidSort:
                                props.onChangeFilterSettingCriteriaStructGuidSort,
                            onChangeFilterSettingCriteriaStructGuid:
                                props.onChangeFilterSettingCriteriaStructGuid,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Подразделение
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria?.struct_guid
                                ?.values ||
                            props.filter?.filter_settings.criteria?.struct_guid
                                ?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Подразделение
                        </div>
                    </div>
                )}
            </div>

            <div className="flex w-40 items-center justify-center text-center h-full rounded-[10px] p-1">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuContractRegNumber}
                        stage={props.stage}
                        popupProps={{
                            criteriaContractRegNumber:
                                props.filter.filter_settings.criteria
                                    ?.contract_reg_number,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaContractRegNumberSort:
                                props.onChangeFilterSettingCriteriaContractRegNumberSort,
                            onChangeFilterSettingCriteriaContractRegNumber:
                                props.onChangeFilterSettingCriteriaContractRegNumber,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Реестровый номер
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.contract_reg_number?.query ||
                            props.filter?.filter_settings.criteria
                                ?.contract_reg_number?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Реестровый номер
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-col w-20 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuDateCreated}
                        stage={props.stage}
                        popupProps={{
                            criteriaCreatedDate:
                                props.filter.filter_settings.criteria
                                    ?.sys_updated_at,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaCreatedDateSort:
                                props.onChangeFilterSettingCriteriaCreatedDateSort,
                            onChangeFilterSettingCriteriaCreatedDate:
                                props.onChangeFilterSettingCriteriaCreatedDate,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                Дата изменения
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.sys_updated_at?.from ||
                            props.filter?.filter_settings.criteria
                                ?.sys_updated_at?.to ||
                            props.filter?.filter_settings.criteria
                                ?.sys_updated_at?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            Дата изменения
                        </div>
                    </div>
                )}
            </div>

            <div className="flex flex-col w-14 h-full items-center justify-center text-center">
                {props.filter?.filter_settings.filter_enabled ? (
                    <TableCellWithPopup
                        PopupComponent={PopupMenuSupervisorUser}
                        stage={props.stage}
                        popupProps={{
                            criteriaSupervisorUserGuid:
                                props.filter.filter_settings.criteria
                                    ?.supervisor_user_guid,
                            onAcceptFilter: props.onAcceptFilter,
                            onChangeFilterSettingCriteriaSupervisorUserGuidSort:
                                props.onChangeFilterSettingCriteriaSupervisorUserGuidSort,
                            onChangeFilterSettingCriteriaSupervisorUserGuid:
                                props.onChangeFilterSettingCriteriaSupervisorUserGuid,
                        }}
                    >
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <div className="flex w-fit h-full items-center justify-center text-center ">
                                <svg
                                    className="w-5 h-5"
                                    xmlns="http://www.w3.org/2000/svg"
                                    data-name="Layer 1"
                                    viewBox="0 0 24 24"
                                    id="user-circle"
                                >
                                    <path
                                        fill={
                                            props.theme == 'dark'
                                                ? '#8A8A8A'
                                                : '#616173'
                                        }
                                        d="M12,2A10,10,0,0,0,4.65,18.76h0a10,10,0,0,0,14.7,0h0A10,10,0,0,0,12,2Zm0,18a8,8,0,0,1-5.55-2.25,6,6,0,0,1,11.1,0A8,8,0,0,1,12,20ZM10,10a2,2,0,1,1,2,2A2,2,0,0,1,10,10Zm8.91,6A8,8,0,0,0,15,12.62a4,4,0,1,0-6,0A8,8,0,0,0,5.09,16,7.92,7.92,0,0,1,4,12a8,8,0,0,1,16,0A7.92,7.92,0,0,1,18.91,16Z"
                                    ></path>
                                </svg>
                            </div>
                        </div>
                        <div>
                            {props.filter?.filter_settings.criteria
                                ?.supervisor_user_guid?.values ||
                            props.filter?.filter_settings.criteria
                                ?.supervisor_user_guid?.sort_order ? (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="filter"
                                >
                                    <path
                                        fill="#4e9aff"
                                        d="M19,2H5A3,3,0,0,0,2,5V6.17a3,3,0,0,0,.25,1.2l0,.06a2.81,2.81,0,0,0,.59.86L9,14.41V21a1,1,0,0,0,.47.85A1,1,0,0,0,10,22a1,1,0,0,0,.45-.11l4-2A1,1,0,0,0,15,19V14.41l6.12-6.12a2.81,2.81,0,0,0,.59-.86l0-.06A3,3,0,0,0,22,6.17V5A3,3,0,0,0,19,2ZM13.29,13.29A1,1,0,0,0,13,14v4.38l-2,1V14a1,1,0,0,0-.29-.71L5.41,8H18.59ZM20,6H4V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z"
                                    ></path>
                                </svg>
                            ) : (
                                <svg
                                    className="w-3 h-3"
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 24 24"
                                    id="angle-down"
                                >
                                    <g transform="rotate(90 12 12)">
                                        <path
                                            fill={
                                                props.theme == 'dark'
                                                    ? '#8A8A8A'
                                                    : '#616173'
                                            }
                                            d="M15.54,11.29,9.88,5.64a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41l4.95,5L8.46,17a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.3,1,1,0,0,0,.71-.3l5.66-5.65A1,1,0,0,0,15.54,11.29Z"
                                        ></path>
                                    </g>
                                </svg>
                            )}
                        </div>
                    </TableCellWithPopup>
                ) : (
                    <div className="flex w-fit h-full items-center justify-center text-center ">
                        <div className="flex w-fit h-full items-center justify-center text-center ">
                            <svg
                                className="w-5 h-5"
                                xmlns="http://www.w3.org/2000/svg"
                                data-name="Layer 1"
                                viewBox="0 0 24 24"
                                id="user-circle"
                            >
                                <path
                                    fill={
                                        props.theme == 'dark'
                                            ? '#8A8A8A'
                                            : '#616173'
                                    }
                                    d="M12,2A10,10,0,0,0,4.65,18.76h0a10,10,0,0,0,14.7,0h0A10,10,0,0,0,12,2Zm0,18a8,8,0,0,1-5.55-2.25,6,6,0,0,1,11.1,0A8,8,0,0,1,12,20ZM10,10a2,2,0,1,1,2,2A2,2,0,0,1,10,10Zm8.91,6A8,8,0,0,0,15,12.62a4,4,0,1,0-6,0A8,8,0,0,0,5.09,16,7.92,7.92,0,0,1,4,12a8,8,0,0,1,16,0A7.92,7.92,0,0,1,18.91,16Z"
                                ></path>
                            </svg>
                        </div>
                    </div>
                )}
            </div>
            {props.hasScroll ? (
                <div className="flex w-3 items-center justify-center text-center h-full rounded-[10px] p-1"></div>
            ) : (
                ''
            )}
        </div>
    )
}

export default TableHeader
